import React from 'react';
import { SkeletonWrapper, StyledLoader } from '../../../styles/HeaderShopThisStoreSkeleton.style'; // assuming style.js is in same folder

const HeaderShopThisStoreSkeleton = () => {
  return (
    <SkeletonWrapper>
      <StyledLoader />
    </SkeletonWrapper>
  );
};

export default HeaderShopThisStoreSkeleton;
